import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import PolicyModal from "@/components/common/PolicyModal";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie-consent", "rejected");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50">
        <div className="mx-auto max-w-6xl px-3 pb-3">
          <div className="bg-primary/95 text-primary-foreground border border-accent/30 shadow-premium backdrop-blur-md rounded-2xl animate-fade-in">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 py-4 px-4 md:px-6">
              <div className="flex flex-col md:flex-row items-center gap-2 md:gap-6">
                <span className="text-accent font-semibold text-sm md:text-base tracking-wide">
                  Controle sua privacidade
                </span>
                <p className="text-primary-foreground/90 text-sm md:text-base text-center md:text-left leading-snug">
                  Nosso site usa cookies para melhorar a navegação.{" "}
                  <button
                    type="button"
                    onClick={() => setPrivacyOpen(true)}
                    className="text-accent underline underline-offset-4 hover:opacity-80 transition-opacity font-semibold"
                  >
                    Política de Privacidade
                  </button>
                </p>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleReject}
                  className="border-primary-foreground/25 bg-transparent text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground"
                >
                  Rejeitar
                </Button>
                <Button variant="gold" size="sm" onClick={handleAccept} className="px-6">
                  Aceitar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PolicyModal open={privacyOpen} onOpenChange={setPrivacyOpen} type="privacy" />
    </>
  );
};

export default CookieConsent;
